import React, {useEffect, useRef, useState} from "react";
import {useWatch, useFormContext, Controller} from "react-hook-form";
import { TextField } from "@mui/material";

const TotalPriceCell = ({ index }: { index: number }) => {
  const { control, setValue } = useFormContext();
  
  const qty = useWatch({ control, name: `checkupPlans.${index}.qty` as any });
  const price = useWatch({ control, name: `checkupPlans.${index}.price` as any });
  const totalPrice = useWatch({ control, name: `checkupPlans.${index}.totalPrice` as any });
  
  const q = parseInt(qty) || 0;
  const p = parseInt(price) || 0;
  const computed = q && p ? (q * p).toString() : "";
  
  const isManual = useRef(false);
  const prevComputed = useRef<string | null>(null); // null = ещё не инициализировано
  
  // Инициализация: первый раз когда computed готов
  useEffect(() => {
    if (prevComputed.current === null && computed) {
      // Если totalPrice с бэка отличается от вычисленного — ручной режим
      const backendValue = totalPrice?.toString() ?? "";
      if (backendValue && backendValue !== computed) {
        isManual.current = true;
      }
      prevComputed.current = computed;
    }
  }, [computed, totalPrice]);
  
  useEffect(() => {
    if (prevComputed.current === null) return; // ещё не инициализировано
    
    if (prevComputed.current !== computed) {
      // qty или price изменились пользователем — сбрасываем ручной режим
      isManual.current = false;
      prevComputed.current = computed;
    }
    
    if (!isManual.current) {
      setValue(`checkupPlans.${index}.totalPrice` as any, computed);
    }
  }, [computed]);
  
  return (
    <Controller
      name={`checkupPlans.${index}.totalPrice` as any}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          variant="standard"
          size="small"
          fullWidth
          placeholder="0"
          onChange={(e) => {
            isManual.current = true;
            field.onChange(e.target.value);
          }}
        />
      )}
    />
  );
};

export default TotalPriceCell;
